import { Inject, Injectable } from '@angular/core';
import { TRANSFER_REPOSITORY, TransfersRepository } from '@core/repositories/transfers.repository';
import { SearchCustomer, SearchReference, TransferEdit } from '@shared/interfaces/transfer';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TransfersService {
  constructor(
    @Inject(TRANSFER_REPOSITORY) protected repository: TransfersRepository
  ) {}

  getItems(): Observable<any> {
    return this.repository.getItems();
  }

  getItemId(data: SearchReference) {
    return this.repository.getItemId(data);
  }

  getItemSearch(data: SearchCustomer) {
    return this.repository.getItemSearch(data);
  }

  validateEdit(data: SearchReference) {
    return this.repository.validateEdit(data);
  }

  validateCancel(data: SearchReference) {
    return this.repository.validateCancel(data);
  }

  validateReverse(data: SearchReference) {
    return this.repository.validateReverse(data);
  }

  edit(transfer: TransferEdit) {
    return this.repository.edit(transfer);
  }

  editId(transfer: TransferEdit) {
    return this.repository.editId(transfer);
  }

  cancel(data: SearchReference) {
    return this.repository.cancel(data);
  }

  reversed(data: SearchReference) {
    return this.repository.reversed(data);
  }
}
